<div class="flex flex-horiz-space-bw m-t-b-10">
    <div>
        <nz-radio-group [(ngModel)]="filterListBy" nzButtonStyle="solid" (ngModelChange)="filterList(filterListBy)">
            <ng-container *ngFor="let item of filterLookup">
                <label class="radioValues" nz-radio-button [nzValue]="item.lookupKey">{{getMappedStatus(item.lookupValue)}}</label>
            </ng-container>
        </nz-radio-group>
    </div>
    <!-- <div>
        <nz-tag class="f-s-16p" nzColor="default">
            <span nz-icon nzType="unordered-list" nzTheme="outline"></span>
            <span>{{filteredDataList.length}}</span>&nbsp;
            <span>{{title}}</span>
        </nz-tag>
        <nz-tag *ngFor="let filteredItem of filteredItemsCount" class="f-s-16p" [nzColor]="filteredItem.color">
            <span nz-icon [nzType]="filteredItem.icon"></span>
            <span>{{filteredItem.count}}</span>&nbsp;
            <span>{{filteredItem.name | technicalTranslate}}</span>
        </nz-tag>
    </div> -->
    <div class="f-s-1-3r p-r-5" *ngIf="filteredDataList && filteredDataList.length > 0">
        <span>{{filteredDataList.length}} {{title}}</span> &bull;
          <ng-container *ngFor="let filteredItem of filteredItemsCount; let last = last;">
            <span nz-typography [nzType]="filteredItem.color">{{filteredItem.count}} {{filteredItem.name}}</span>
            <span *ngIf="!last">&bull;</span>
          </ng-container>
    </div>
</div>

<div class="heading-tab">
<h3 class="heading d-b m-t-b-20">
    <span nz-icon nzType="profile" nzTheme="outline" class="m-r-5"></span>
    Showing {{filterListBy.toString().toLowerCase()}} {{title | lowercase}} ({{filteredDataList.length}})
</h3>
<!-- <div>
    <button nz-button class="m-r-10" [nzType]="'primary'" (click)="openTranslateModal=true">Explain Rules</button>
  </div> -->
</div>

<nz-table *ngIf="filteredDataList && filteredDataList.length > 0" #dataListTable nzBordered [nzData]="filteredDataList">
    <thead (nzSortOrderChange)="sort($event)" nzSingleSort>
        <tr>
            <ng-container *ngFor="let item of dataListConfig.listHeader">
                <ng-container *ngIf="item.isVisible">
                    <th *ngIf="item.sortFilter && item.searchFilter; else showHeaderWithSortOnly" nzCustomFilter
                        nzShowSort [nzColumnKey]="item.key" [nzWidth]="item.width">
                        {{item.header}}
                        <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                            (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                            <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                        </nz-filter-trigger>
                    </th>
                    <ng-template #showHeaderWithSortOnly>
                        <th *ngIf="item.sortFilter; else showSearchFilterOnly" nzShowSort [nzColumnKey]="item.key"
                            [nzWidth]="item.width">
                            {{item.header}}
                        </th>
                    </ng-template>
                    <ng-template #showHeaderWithSortOnly>
                        <th *ngIf="item.sortFilter; else showSearchFilterOnly" nzShowSort [nzColumnKey]="item.key"
                            [nzWidth]="item.width">
                            {{item.header}}
                        </th>
                    </ng-template>
                    <ng-template #showSearchFilterOnly>
                        <th *ngIf="item.searchFilter; else showOnlyTableHeader" nzCustomFilter [nzColumnKey]="item.key"
                            [nzWidth]="item.width">
                            {{item.header}}
                            <nz-filter-trigger [nzDropdownMenu]="searchFilterMenu"
                                (nzVisibleChange)="filterMenuVisibilityChanged($event)">
                                <i nz-icon nzType="search" (click)="getConfigKey(item.key)"></i>
                            </nz-filter-trigger>
                        </th>
                    </ng-template>
                    <ng-template #showOnlyTableHeader>
                        <th [nzWidth]="item.width">{{item.header}}</th>
                    </ng-template>


                </ng-container>
            </ng-container>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let data of dataListTable.data">
            <ng-container *ngFor="let config of dataListConfig.listHeader">
                <ng-container *ngIf="config.isVisible">
                    <!-- <td *ngIf="config.applyColor; else showDataWithoutColor" nz-typography
                        [nzType]="data['color'] == 'error' ? 'danger' : data['color']">
                        <span *ngIf="config.pipe;else showColoredDataOnly">{{ (data[config.key] | technicalTranslate) ||
                            '-' }}</span>
                        <ng-template #showColoredDataOnly>{{ data[config.key] || '-' }}</ng-template>
                    </td> -->

                    <td *ngIf="config.applyColor ; else showDataWithoutColor" nz-typography [nzType]="data['color'] == 'error' || data['decision'] === 'Reject' || data['decision'] === 'Rejected' || data['decision'] === 'REJECT' || data['decision'] === 'REJECTED' ? 'danger' : data['color' ]">
                        <ng-container *ngIf="config.key === 'decision'; else showColoredDataOnly">
                            <ng-container *ngIf="data['decision'] === 'STANDARD'">Auto-Approve</ng-container>
                            <ng-container *ngIf="data['decision'] === 'Reject' || data['decision'] === 'Rejected' || data['decision'] === 'REJECT' || data['decision'] === 'REJECTED'">Auto-Reject</ng-container>
                            <ng-container *ngIf="data['decision'] === 'REFER'">Manual Review</ng-container>
                            <ng-container *ngIf="!(data['decision'] === 'STANDARD' || data['decision'] === 'Reject' || data['decision'] === 'REFER' || data['decision'] === 'Rejected' || data['decision'] === 'REJECT' || data['decision'] === 'REJECTED')"> 
                                <span>{{ (data['decision'] | technicalTranslate) || '-' }}</span>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="config.key !== 'decision'; else showColoredDataOnly">
                            <span>{{ (data[config.key] | technicalTranslate) || '-' }}</span>
                        </ng-container>
                    </td>
                    
                    
                    
                    
                    <ng-template #showDataWithoutColor>
                        <td>
                            <span *ngIf="config.pipe;else showDataOnly">{{ (data[config.key] | technicalTranslate) ||
                                '-' }}</span>
                            <ng-template #showDataOnly>{{ data[config.key] || '-' }}</ng-template>
                        </td>
                    </ng-template>
                </ng-container>
            </ng-container>
        </tr>
    </tbody>
</nz-table>

<nz-dropdown-menu #searchFilterMenu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
        <div class="search-box">
            <input type="text" nz-input placeholder="Filter..." [(ngModel)]="searchValue" />
            <button nz-button nzSize="small" nzType="primary" (click)="searchConfiguration(searchValue)"
                class="search-button">
                Filter
            </button>
            <button nz-button nzSize="small" (click)="reset()">Reset</button>
        </div>
    </div>
</nz-dropdown-menu>

<app-generic-zero-ui [list]="filteredDataList" icon="question-circle" title="No Data"
     message="No Data found in the List"></app-generic-zero-ui>

<nz-modal [(nzVisible)]="openTranslateModal" nzTitle="Rules Explanation" [nzClosable]="true" [nzMaskClosable]="false"
    (nzOnCancel)="openTranslateModal=false" nzCancelText="Close" [nzOkText]="null" nzWidth="75%">
    <ng-container *nzModalContent>
        <div *ngIf="openTranslateModal" class="tab-grid m-t-20">
            <nz-select nzShowSearch class="w-100-pc" [(ngModel)]="selectedLanguage" nzPlaceHolder="Select Language" nzAllowClear>
                <!-- <nz-option *ngFor="let item of (lookup$.translationLanguageCd | async); trackBy:item?.lookupKey"
                    [nzLabel]="item?.lookupValue" [nzValue]="item?.lookupKey"></nz-option> -->
                    <nz-option *ngFor="let lookup of translationLanguageLookup" [nzLabel]="lookup?.lookupValue"
                            [nzValue]="lookup?.lookupKey"></nz-option>
                    <nz-option nzLabel="English" nzValue = "English"></nz-option>
            </nz-select>
            <button nz-button nzType="primary" (click)="translateRules(selectedLanguage)" class="search-button">
                Explain
            </button>
        </div>
        <nz-spin [nzSize]="'large'" [nzSpinning]="loadSpinner">
            <div class="m-t-b-20">
                <nz-table [nzData]="translatedRules" #translatedRulesTable [nzShowPagination]="true"
                    [nzScroll]="{x:'1000px'}">
                    <thead class="table-header">
                        <tr>
                            <th nzWidth="90px">Sr No.</th>
                            <th>Rules</th>
                            <th>Explanation</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let rule of translatedRulesTable.data; let i=index">
                            <td>{{rule.id}}</td>
                            <td>{{rule.Actual_Text}}</td>
                            <td>{{rule.Translated_Text}}</td>
                        </tr>
                    </tbody>
                </nz-table>
            </div>
        </nz-spin>
    </ng-container>
</nz-modal>